import { render, staticRenderFns } from "./chatLog.vue?vue&type=template&id=0657f04d&"
import script from "./chatLog.vue?vue&type=script&lang=ts&"
export * from "./chatLog.vue?vue&type=script&lang=ts&"
import style0 from "./chatLog.vue?vue&type=style&index=0&id=0657f04d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports